export default __webpack_public_path__ + "static/media/ensen.69d82aaa.png";